<footer class="bg-white py-4">
  <div class="max-w-screen-xl mx-auto px-4">
    <div class="text-center text-sm text-gray-700">
      © 2025 Copyright, <b class="text-slate-800">LinkageIT</b>®
    </div>
  </div>
</footer>
